export const permissoesPerfil = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_VISUALIZAR,
  process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_EDITAR,
  process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_TOTAL,
]

export const permissoesUsuarios = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_USUARIOS_CADASTRO_USUARIOS_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_USUARIOS_CADASTRO_USUARIOS_EDITAR_CONDICIONADO,
  process.env.VUE_APP_USUARIOS_CADASTRO_USUARIOS_TOTAL,
]

export const permissoesAuditoria = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_USUARIOS_AUDITORIA_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_USUARIOS_AUDITORIA_TOTAL,
]

export const permissoesToken = [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_USUARIOS_TOKEN_VISUALIZAR]
